import { Component, Input, OnInit } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierService
    , CarrierServiceMap
} from '../../models/models';

@Component({
    selector: 'carrier-service-assigned',
    templateUrl: './carrier-service-assigned.component.html',
    standalone: false
})
export class CarrierServiceAssigned implements OnInit {
    @Input() carrierID: number = 0;
    public isLoading: boolean = false;

    //public selectedCarrierServices: Employee[] = [];
    public carrierServiceList: CarrierService[] = [];
    public carrierServiceIDList: number[] = [];

    constructor(private cseService: CSEService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.getCarrierServices();
    }

    private getCarrierServices() {
        this.utilService.isLoading = true;
        this.cseService.getAllCarrierServices().subscribe(result => {
            this.utilService.isLoading = false;
            this.carrierServiceList = result;
            this.getCarrierServiceMaps();
        });
    }

    private getCarrierServiceMaps() {
        this.utilService.isLoading = true;
        this.cseService.getServiceMapsByCarrierId(this.carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result == null) return;

            result.forEach(s => {
                this.carrierServiceIDList.push(s.carrierServiceID);
                var service = this.carrierServiceList.find(t => t.carrierServiceID == s.carrierServiceID);
                if (service != null) {
                    service.isChecked = true;
                }
            });
        });
    }

    public setCarrierServiceMap(service: CarrierService) {
        service.isChecked = !service.isChecked;
        this.saveCarrierServiceMaps(service);
    }

    public saveCarrierServiceMaps(service: CarrierService) {
        var idx = this.carrierServiceIDList.indexOf(service.carrierServiceID);
        if (!service.isChecked && idx >= 0) {
            this.carrierServiceIDList.splice(idx, 1);
        }
        else if (idx < 0) {
            this.carrierServiceIDList.push(service.carrierServiceID);
        }

        console.log("saveCarrierServiceMaps", idx, this.carrierServiceIDList, service);

        let maps: CarrierServiceMap[] = [];

        if (this.carrierServiceIDList.length > 0) {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.carrierServiceIDList.forEach(s => {
                var map = {
                    carrierID: this.carrierID,
                    carrierServiceID: s,
                    carrierServiceMapID: 0,
                    createdDate: new Date(),
                    employeeID: employeeID
                } as CarrierServiceMap;

                maps.push(map);
            });

            this.utilService.isLoading = true;
            this.cseService.saveCarrierServiceMaps(maps).subscribe(result => {
                this.utilService.isLoading = false;
                var ok = result;
            });
        } else {
            this.utilService.isLoading = true;
            this.cseService.deleteCarrierServiceMapsByCarrierId(this.carrierID).subscribe(result => {
                this.utilService.isLoading = false;
                var ok = result;
            });
        }
    }
}
